import _ from 'lodash'

export const ADD_SERVICE = 'ADD_SERVICE'
export const SET_CURRENT_SERVICE = 'SET_CURRENT_SERVICE'
export const PERSIST_SERVICES = 'PERSIST_SERVICES'

// Initial state
const state = {
  services: JSON.parse(localStorage.getItem('services')) === null ? {} : JSON.parse(localStorage.getItem('services'))
}

// Getters
const getters = {
  allServices: state => {
    let services = []
    _.forIn(state.services.serviceDetails, (value, key) => {
      services.push({
        serviceCode: key,
        ...value
      })
    })
    return services
  },
  currentService: (state, getters) => {
    const currentServiceCode = localStorage.getItem('current_service')

    console.log('Did the user already preselect a service?', !!currentServiceCode)

    if ((currentServiceCode === null) || (state.services.serviceDetails[currentServiceCode] === undefined)) {
      if (getters.allServices.length > 0) {
        const currentService = getters.allServices[0]
        localStorage.setItem('current_service', currentService.serviceCode)
        return currentService
      }

      return {}
    }

    return {
      serviceCode: currentServiceCode,
      ...state.services.serviceDetails[currentServiceCode]
    }
  }
}

// Mutations
const mutations = {
  [ADD_SERVICE] (state, service) {
    state.services.serviceDetails = {
      ...state.services.serviceDetails,
      [service.serviceCode]: {
        serviceName: service.serviceName,
        serviceID: service.serviceID,
        active: '1'
      }
    }

    localStorage.setItem('services', JSON.stringify(state.services))
  },

  [SET_CURRENT_SERVICE] (state, service) {
    localStorage.setItem('current_service', service.serviceCode)
  },

  [PERSIST_SERVICES] (state, services) {
    state.services = services
  }
}

// Actions
const actions = {
  addService ({ commit }, service) {
    commit(ADD_SERVICE, service)
    commit(SET_CURRENT_SERVICE, service)
  },

  saveServices ({ commit }, services) {
    localStorage.setItem('services', JSON.stringify(services))
    commit(PERSIST_SERVICES, services)
  },

  updateService ({ dispatch }, service) {
    dispatch('addService', service)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/services.js